import { IonIcon } from '@ionic/react';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { logoFacebook, logoInstagram, logoLinkedin } from 'ionicons/icons';
import { Link } from 'react-router-dom';
import { AppContext } from '../../state/AppContextProvider';

interface FooterProps {}

type Logo = {
  src: string;
  alt: string;
};
const logo: Logo = {
  src: '/assets/logo/LOGO.svg',
  alt: 'Logo CIUP',
};

const Footer: React.FC<FooterProps> = () => {
  const { state } = useContext(AppContext);

  if (state.isConnected) {
    return (
      <div
        id="footer-desktop"
        style={{ backgroundImage: 'url("/assets/img/bg-footer.png")' }}
        className="z-10 absolute hidden w-64 px-6 text-center bottom-0 left-0 bg-contain bg-right-bottom bg-no-repeat md:flex md:flex-col justify-end gap-4"
      >
        <div className="social-links">
          <ul className="flex flex-row justify-between items-center mx-auto w-3/6">
            <li>
              <a
                href="https://www.facebook.com/cite.internationale.universitaire"
                rel="noreferrer"
                target="_blank"
              >
                <IonIcon icon={logoFacebook} />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/citeinternationaleparis/"
                rel="noreferrer"
                target="_blank"
              >
                <IonIcon icon={logoInstagram} />
              </a>
            </li>
            <li>
              <a
                href="http://www.linkedin.com/company/cite-internationale-universitaire-de-paris"
                rel="noreferrer"
                target="_blank"
              >
                <IonIcon icon={logoLinkedin} />
              </a>
            </li>
          </ul>
        </div>
        <div className="logo w-full h-full mx-auto text-center content-center">
          <img className="w-full h-full" alt={logo.alt} src={logo.src} />
        </div>
        <div className="legal-links">
          <ul className="w-full flex flex-col justify-center px-6 mb-5">
            <li>
              <Link
                to="/pages/faq"
                className="text-black opacity-40 text-xs font-medium"
              >
                <FormattedMessage id="FAQ" />
              </Link>
            </li>
            <li>
              <Link
                to="/pages/policy"
                className="text-black opacity-40 text-xs font-medium"
              >
                <FormattedMessage id="Privacy Policy" />
              </Link>
            </li>
            <li>
              <Link
                to="/pages/legal"
                className="text-black opacity-40 text-xs font-medium"
              >
                <FormattedMessage id="Legal Notice" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  } else {
    return <div className="hidden"></div>;
  }
};

export default Footer;
